module.exports = __webpack_public_path__ + "static/media/LICHSGFIN_F1.97548a8b.txt";